module.exports = "<div class=\"ml-5\" >\n    <ContentLoader :primaryColor=\"dtPalette['grey-3']\" >\n        <rect x=\"10\" y=\"20\" rx=\"3\" ry=\"3\" width=\"220\" height=\"10\" />\n        <rect x=\"0\" y=\"40\" rx=\"3\" ry=\"3\" width=\"330\" height=\"130\" />\n    </ContentLoader>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/home/loaders/chart-loader/template.html
// module id = RDWc
// module chunks = 0